import { render, staticRenderFns } from "./ReletedRuleDialog.vue?vue&type=template&id=77293272&scoped=true&"
import script from "./ReletedRuleDialog.vue?vue&type=script&lang=js&"
export * from "./ReletedRuleDialog.vue?vue&type=script&lang=js&"
import style0 from "./ReletedRuleDialog.vue?vue&type=style&index=0&id=77293272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77293272",
  null
  
)

export default component.exports